import { Injectable } from '@angular/core';
import { DeviceAssignmentHistory } from '@era/locations-sdk';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';
import { DeviceAssignmentHistoryStoreActions } from './device-assignment-history-store';
import { DevicesRouterStoreSelectors, RouterStoreStates } from '../../../../stores/router';
@Injectable()
export class DeviceAssignmentHistoryResolver {
  constructor(
    private readonly deviceAssignmentHistoryStore: Store<DeviceAssignmentHistory>,
    private readonly routerStore: Store<RouterStoreStates.RouterState>
  ) {}

  resolve(): Observable<boolean> {
    return this.routerStore.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((udid) => {
        this.deviceAssignmentHistoryStore.dispatch(
          DeviceAssignmentHistoryStoreActions.DeviceAssignmentHistoryResolverActions.historyRequested({ udid })
        );
      }),
      map(() => true),
      first()
    );
  }
}
